<template>
<div class="content sunset">
	<div class="hero-image">
		<DatocmsImage v-if="content.heroImage" :data="content.heroImage.responsiveImage" />
		<h1>return true;</h1>
	</div>
	<div class="red-bar">
		Use our referral link <B>jeffrey51305</B> to get discounts on a new Tesla purchase!
		<a href="https://ts.la/jeffrey51305" class="btn-secondary">Go</a>
	</div>
	<div class="container">
		<div class="row content-body">
			<div class="col-sm-12 col-md-12">
				<p>This site started as a personal project — I just wanted to find myself a black Model S at the right price. The existing tools weren't cutting it, so I built my own.</p>
				<p>Then I figured, why not let other people use it too?</p>
				<p>Over the years, this little side project sent out over a million email alerts and helped more than 1,000 people find their Teslas. I never did qualify for that free Roadster, but it was worth it.</p>
				<p>The site hasn't been actively maintained for a while now, and it's time to officially turn the lights off. Thank you to everyone who used it — I'm glad it helped.</p>
				<p>If you're still in the market for a new Tesla, you can use <a href="https://www.tesla.com/referral/jeffrey51305" target="_blank">my referral link</a> to get whatever discount Tesla is currently offering.</p>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import { Image } from 'vue-datocms';
export default {
	components: {
		DatocmsImage: Image,
	},
	data() {
		return {
			content:
		{
  "title": "The Best Way To Buy &amp; Sell A Tesla",
  "heroImage": {
    "responsiveImage": {
      "aspectRatio": 1.7772511848341233,
      "height": 422,
      "sizes": "(max-width: 750px) 100vw, 750px",
      "src": "https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;fit=crop&amp;w=750",
      "srcSet": "https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=0.25&amp;fit=crop&amp;w=750 187w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=0.5&amp;fit=crop&amp;w=750 375w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=0.75&amp;fit=crop&amp;w=750 562w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;fit=crop&amp;w=750 750w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=1.5&amp;fit=crop&amp;w=750 1125w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=2&amp;fit=crop&amp;w=750 1500w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=3&amp;fit=crop&amp;w=750 2250w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=4&amp;fit=crop&amp;w=750 3000w",
      "webpSrcSet": "https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=0.25&amp;fit=crop&amp;fm=webp&amp;w=750 187w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=0.5&amp;fit=crop&amp;fm=webp&amp;w=750 375w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=0.75&amp;fit=crop&amp;fm=webp&amp;w=750 562w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;fit=crop&amp;fm=webp&amp;w=750 750w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=1.5&amp;fit=crop&amp;fm=webp&amp;w=750 1125w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=2&amp;fit=crop&amp;fm=webp&amp;w=750 1500w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=3&amp;fit=crop&amp;fm=webp&amp;w=750 2250w,https://www.datocms-assets.com/87997/1670357931-about.jpg?ar64=MTY6OQ&amp;dpr=4&amp;fit=crop&amp;fm=webp&amp;w=750 3000w",
      "width": 750,
      "alt": null,
      "title": null
    }
  }
}
		,
		}
	},
	head() {
		return {
			title: "PRE-USED EV",
			bodyAttrs: {
				class: "content-page home-page"
			}
		}
	},
	async asyncData() {
		/*
		const response = await fetch('https://graphql.datocms.com/', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: "Bearer 1a38e85c5b3ab3f6e89d0f1ff3360e",
			},
			body: JSON.stringify({
				query: `
					query getPost {
						allPosts(filter: {slug: {eq: "home-page"}}) {
							title
							heroImage {
								responsiveImage(imgixParams: { fit: crop, ar: "16:9", w: 750 }){
									aspectRatio
									height
									sizes
									src
									srcSet
									webpSrcSet
									width
									alt
									title
								}
							}
						}
					}
				`
			})
		})
		const { data: contentData } = await response.json()
		return {
			content: contentData?.allPosts[0],
		}
			*/
	}
}
</script>
<style lang="scss">

</style>
